import React from "react";

interface StatCardProps {
  label: string;
  value: string;
  emphasis?: boolean; // highlight the headline metric (e.g. Net Sales)
}

// Small KPI tile for the top-of-report summary. Totals shown here come straight
// from the engine's `totals` (same definitions as the table) so they can never
// disagree with the rows below.
export default function StatCard({ label, value, emphasis }: StatCardProps) {
  return (
    <div
      className={`rounded-md border px-4 py-3 shadow-sm ${
        emphasis ? "border-primary-600 bg-primary-50" : "border-gray-200 bg-white"
      }`}
    >
      <div className="text-xs font-medium uppercase tracking-wide text-gray-500">
        {label}
      </div>
      <div
        className={`mt-1 text-xl font-bold ${
          emphasis ? "text-primary-700" : "text-gray-900"
        }`}
      >
        {value}
      </div>
    </div>
  );
}
